import React, { useState } from "react";
import { CpButton, CpModal, CpCheckbox } from "canopy-styleguide!sofe";

type SkipSetupModalProps = {
  onClose: () => void;
  onConfirm: (dontShowAgain: boolean) => void;
};

export function SkipSetupModal({ onClose, onConfirm }: SkipSetupModalProps) {
  const [showModal, setShowModal] = useState(true);
  const [checked, setChecked] = useState(false);
  const closeModal = () => setShowModal(false);
  const handleConfirm = () => {
    onConfirm(checked);
    closeModal();
  };

  return (
    <CpModal show={showModal} onClose={closeModal} onAfterClose={onClose} width={520}>
      <CpModal.Header title="Skip setup" />
      <CpModal.Body>
        <div className="cp-mb-16">
          Are you sure you want to skip setup? You will continue to get the setup until completed or choose to check the
          box below and finish these steps in Settings.
        </div>
        <CpCheckbox checked={checked} onChange={setChecked}>
          Don't show me this company setup again
        </CpCheckbox>
      </CpModal.Body>
      <CpModal.Footer>
        <CpButton btnType="primary" className="cp-mr-8" onClick={handleConfirm}>
          Skip and go to Canopy
        </CpButton>
        <CpButton btnType="flat" onClick={closeModal}>
          Cancel
        </CpButton>
      </CpModal.Footer>
    </CpModal>
  );
}
